module.exports = __webpack_public_path__ + "media/assets/pngs/welcomeCarousel0-2bdb422d0340884b4dfd0043f738ca67.png";